/**
 * Activation In Progress Component
 * Based on Figma: https://www.figma.com/design/8nBzg5I71TF3EWyr6NcpVa/Fiat?node-id=4021-78628
 */
import { Clock } from 'lucide-react';

import { Button } from '@components/ui/button';

interface ActivationInProgressProps {
  /**
   * Callback when "Return to deposits" button is clicked
   */
  onReturnToDeposits: () => void;
}

export function ActivationInProgress({
  onReturnToDeposits,
}: ActivationInProgressProps) {
  return (
    <div className="pt-5 sm:w-[394px]">
      {/* Content Section */}
      <div className="flex flex-col gap-3">
        {/* Warning Icon */}
        <Clock className="size-6" />
        <h2 className="text-foreground">Activating your cash transfers</h2>
        <p className="text-muted-foreground text-body-paragraph1">
          Check back in a few minutes
        </p>
      </div>

      {/* Action Button */}
      <div className="mt-6 flex">
        <Button
          type="button"
          variant="primary"
          onClick={onReturnToDeposits}
          className="flex-1"
        >
          Return to deposits
        </Button>
      </div>
    </div>
  );
}
